import React, { useState } from "react";
import { CrewPilotModuleShell } from "../CrewPilotModuleShell";
import { PAGE_LAYOUT } from "../../layout/pageLayout";
import { useOrganization } from "../../context/OrganizationContext";
import { useIsDesktopViewport } from "../../hooks/useIsDesktopViewport";
import { AdmSwitchRow } from "./desktop/AdmKit";

export function AdminFeatureFlagsScreen({ onBack }) {
  const { settings, updateSettings, error } = useOrganization();
  const isDesktop = useIsDesktopViewport();
  const [saved, setSaved] = useState(false);
  const [saving, setSaving] = useState(false);

  const guestModeEnabled = settings.guest_mode_enabled !== false;
  const payrollSelfService = settings.payroll_self_service !== false;

  const handleToggle = async (key, value) => {
    setSaving(true);
    try {
      await updateSettings({ [key]: value });
      setSaved(true);
      window.setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <CrewPilotModuleShell
      title="Feature Flags"
      subtitle="Organization module toggles"
      sectionLabel="Company"
      onBack={onBack}
      layout={PAGE_LAYOUT.FORM}
    >
      <div className="adm-narrow">
      <div className="rb-card">
        <div className="section-heading">ORGANIZATION TOGGLES</div>

        {error && (
          <p className="admin-placeholder-note" style={{ marginBottom: "12px" }}>
            Database sync unavailable. Toggles are cached locally until online.
          </p>
        )}

        {isDesktop ? (
          <>
            <AdmSwitchRow
              title="Guest demo mode enabled"
              checked={guestModeEnabled}
              disabled={saving}
              onChange={(value) => handleToggle("guest_mode_enabled", value)}
            />
            <AdmSwitchRow
              title="Employee payroll self-service"
              checked={payrollSelfService}
              disabled={saving}
              onChange={(value) => handleToggle("payroll_self_service", value)}
            />
          </>
        ) : (
          <>
        <label className="admin-toggle-row">
          <input
            type="checkbox"
            checked={guestModeEnabled}
            disabled={saving}
            onChange={(event) =>
              handleToggle("guest_mode_enabled", event.target.checked)
            }
          />
          <span>Guest demo mode enabled</span>
        </label>

        <label className="admin-toggle-row">
          <input
            type="checkbox"
            checked={payrollSelfService}
            disabled={saving}
            onChange={(event) =>
              handleToggle("payroll_self_service", event.target.checked)
            }
          />
          <span>Employee payroll self-service</span>
        </label>
          </>
        )}

        {saved && (
          <p className="admin-save-confirmation" role="status">
            Feature flags updated.
          </p>
        )}
      </div>
      </div>
    </CrewPilotModuleShell>
  );
}
